import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, ShieldAlert } from "lucide-react";
import { api, errMsg, inr, tone } from "@/lib/api";

const F = ({ label, k, f, set, type = "number", hint }) => (
  <label className="flex flex-col gap-1"><span className="widget-title">{label}</span>
    <input data-testid={`risk-${k}`} type={type} className="field" value={f[k]} onChange={(e) => set({ ...f, [k]: e.target.value })} />{hint && <span className="text-[10px] text-slate-500">{hint}</span>}</label>
);
const C = ({ label, k, f, set }) => (
  <label className="flex items-center gap-2 h-8 text-xs text-slate-300 cursor-pointer"><input data-testid={`risk-${k}`} type="checkbox" checked={!!f[k]} onChange={(e) => set({ ...f, [k]: e.target.checked })} className="accent-[#22A34A]" /> {label}</label>
);

export default function RiskSettings() {
  const [f, setF] = useState(null);
  const [today, setToday] = useState(0);
  useEffect(() => { api.get("/nexfin/risk").then((r) => { const { defaults, today_pnl, ...rest } = r.data; setF(rest); setToday(today_pnl); }); }, []);
  const save = async () => {
    try {
      const body = { ...f, max_loss_day: Number(f.max_loss_day), max_loss_trade: Number(f.max_loss_trade), max_lots: Number(f.max_lots), max_open_positions: Number(f.max_open_positions), rapid_fire_sec: Number(f.rapid_fire_sec) };
      const r = await api.put("/nexfin/risk", body); setF(r.data); toast.success("Risk settings saved");
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!f) return null;
  return (
    <div className="space-y-3 rise" data-testid="risk-page">
      <div className="flex items-center gap-3"><h1 className="font-display text-xl font-bold text-white tracking-tight">Risk Settings</h1><span className="text-xs font-mono text-slate-400">Today realised: <span className={tone(today)}>{inr(today)}</span></span></div>
      <div className="panel p-4 space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <F label="Max loss / day (₹)" k="max_loss_day" f={f} set={setF} hint="blocks new entries once reached" />
          <F label="Max loss / trade (₹)" k="max_loss_trade" f={f} set={setF} hint="stop distance × qty must fit" />
          <F label="Max lots" k="max_lots" f={f} set={setF} />
          <F label="Max open positions" k="max_open_positions" f={f} set={setF} />
          <F label="Window start" k="window_start" f={f} set={setF} type="text" />
          <F label="Window end" k="window_end" f={f} set={setF} type="text" />
          <F label="Rapid-fire guard (sec)" k="rapid_fire_sec" f={f} set={setF} />
        </div>
        <div className="flex flex-wrap gap-6">
          <C label="Auto square-off at session end" k="auto_square_off" f={f} set={setF} />
          <C label="Duplicate order protection" k="duplicate_protection" f={f} set={setF} />
          <C label="Margin check before entry" k="margin_check" f={f} set={setF} />
        </div>
        <div className="flex items-start gap-2 text-[11px] text-slate-500 border border-[#163056] p-3 rounded-sm"><ShieldAlert className="w-4 h-4 text-amber-400 shrink-0" />
          Every order passes through the risk manager before reaching the broker. If the broker session or data feed drops while a position is open you get an immediate Telegram alert and a Manual Exit button in Positions. The Kill Switch (Dashboard) exits all positions and stops all strategies.</div>
        <button data-testid="risk-save-button" onClick={save} className="btn-primary h-9"><Save className="w-4 h-4" /> Save risk settings</button>
      </div>
    </div>
  );
}
